import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=15b1bce2&"
import script from "./Header.vue?vue&type=script&lang=ts&"
export * from "./Header.vue?vue&type=script&lang=ts&"
import style0 from "./Header.vue?vue&type=style&index=0&id=15b1bce2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15b1bce2')) {
      api.createRecord('15b1bce2', component.options)
    } else {
      api.reload('15b1bce2', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=15b1bce2&", function () {
      api.rerender('15b1bce2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/layout/Header.vue"
export default component.exports